import type { Translations } from '~/utils/translations/types';

const en: Translations = {
  apply: {
    congrat_1_steps: 'Scan the QR code from your smartphone camera',
    congrat_2_steps: 'Download the app and finalize your profile',
    congrat_3_steps: 'Access your application and hundreds of missions near you',
    download_app: 'Download',
    form_address_label: 'Address',
    form_address_placeholder: '646 Michigan Ave, Chicago, IL 60611, USA',
    form_email_label: 'E-mail',
    form_email_placeholder: 'johndoe@gmail.com',
    form_email_placeholder_pm: 'johndoe@gmail.com',
    form_firstname_label: 'First name',
    form_firstname_placeholder: 'John',
    form_lastname_label: 'Last name',
    form_lastname_placeholder: 'Doe',
    form_phone_label: 'Phone',
    form_phone_placeholder: '1 (312) 555-3890',
    form_resume_button: 'Import',
    form_resume_label: 'CV',
    form_resume_label_pstf: 'Resume',
    message_info_accept_conditions: 'well as the',
    message_info_accept_tcu: 'By continuing, you agree to the',
    modal_action_apply: 'Apply',
    modal_action_close: 'Close',
    step_unknown: {
      dropzone: {
        drop: 'Drop or ',
        select: 'select your file',
        supported_files: 'Supported files : IMAGES, PDF, DOC, DOCX',
      },
    },
    subtitle_download_app: 'Download our app to track your application.',
    subtitle_email_to_identify: 'Your email allows us to identify if we already know each other.',
    subtitle_resume_to_apply: 'We need your CV and contact details to process your application.',
    subtitle_resume_to_apply_pstf: 'We need your resume and contact details to process your application.',
    tcu_conditions: 'Privacy Policy',
    tcu_confidentiality: 'Terms of Service',
    title_congratulation: 'Well done, your application has been sent!',
    title_free_apply: 'Apply for a mission',
    title_job_offer_apply: 'Apply for this mission',
    title_you_are_new: "We don't know each other yet!",
  },
  banner: {
    join_community: 'Join the <span>{{name}}</span> community',
    large_choice: 'Wide selection of jobs',
    large_choice_desc:
      'I have access to a wide range of temporary, fixed-term and permanent positions in my area, across all fields that interest me.',
    personal_service: 'Personalized & rewarding support',
    personal_service_desc:
      'My dedicated recruitment manager supports me day-to-day. The more I work with us, the more benefits I receive!',
    personal_service_desc_pm:
      'My dedicated recruitment manager supports me day-to-day. The more I work with us, the more benefits I receive!',
    simple_and_fast: 'Simple & quick',
    simple_and_fast_desc:
      'No more trips to the agency: I choose my assignment in 3 clicks, I simply upload my documents.',
  },
  breadcrumbs: {
    home: 'Home',
  },
  buttons: { contact_us: 'Contact us', load_more: 'Load more' },
  cities_page: {
    meta_description:
      'Find our temporary, permanent, and fixed-term contract job offers and apply in just a few clicks',
    meta_title: 'Our job offers by city - iziwork',
    title: 'All cities',
  },
  city_job_page: {
    heading: 'Work as a {{job}} in {{city}}',

    latest_job_offers: 'Our latest {{job}} offers in {{city}}',
    meta_description:
      'Find our temporary, permanent, and fixed-term contract job offers for the profession of {{job}} in {{city}} and apply in just a few clicks',
    meta_title: 'Our job offers in {{job}} in {{city}} - iziwork',
    title: 'Our <span>{{job}}</span> offers in <span>{{city}}</span>',
  },
  city_page: {
    heading: 'Work in {{city}}',
    latest_job_offers: 'Our latest offers in {{city}}',
    meta_description:
      'Temporary, fixed-term and permanent job offers in {{city}}: order picker, forklift operator, warehouse worker… Apply online in a few clicks with iziwork.',
    meta_title: 'Our job offers in {{city}} - iziwork',
    title: 'Our offers in <span>{{city}}</span>',
  },
  consent_manager: {
    content:
      'We use the information collected by cookies and JavaScript libraries to improve your browsing experience, analyze traffic on our site, display personalized advertisements and increase the performance of our site.',
    title: 'Manage my preferences',
  },
  date: {
    today: 'today',
  },
  error_pages: {
    internal_server_error_title: 'Oops, there was an error...',
    not_found_subtitle1: "Don't worry, our developpers are looking for it!",
    not_found_subtitle2: 'Until then, you can go back to the previous page.',
    not_found_title: "Oops, it seems like the page you're looking for disappeared...",
    redirect_label: 'Back home',
  },
  expired_job_offer: {
    meta_title: 'Expired offer: {{title}} in {{city}}',
    meta_title_without_city: 'Expired offer: {{title}}',
    subtitle: 'The {{title}} offer in {{city}} has been filled or withdrawn. Discover other offers near you.',
    subtitle_without_city: 'The {{title}} offer has been filled or withdrawn. Discover other offers near you.',
    title: 'This offer is no longer available',
  },
  field_errors: {
    address_valueIncomplete: 'Address is incomplete',
    address_valueMissing: 'Address is required',
    captcha_valueMissing: 'The field is required',
    email_typeMismatch: 'Email is incorrect',
    email_valueMissing: 'Email is required',
    firstname_valueMissing: 'First name is required',
    lastname_valueMissing: 'Name is required',
    phone_typeMismatch: 'Phone is incorrect',
    phone_valueMissing: 'Phone is required',
    resume_invalidSize: 'The file size must be between 1KB and 10MB',
    resume_invalidType: 'The file type is not valid',
    resume_valueMissing: 'CV is required',
    resume_valueMissing_pstf: 'Resume is required',
  },
  footer: {
    aboutUs: 'About Us',
    account: 'My Account',
    askADemo: 'Ask for a demo',
    blog: 'Blog',
    companies: 'Companies',
    companySpace: 'Business space',
    confidentiality: 'Confidentiality',
    cookies_policy: 'Cookies Policy',
    cookies_settings: 'Cookies settings',
    join: 'Join us',
    legal_mentions: 'Legal notice',
    partners: 'Partners',
    personalData: 'Personal Data',
    press: 'Press',
    program: 'Partners Program',
    rgpd: 'Your GDPR rights',
    sitemap: 'Sitemap',
    socialMedia: {
      facebook: 'Follow us on Facebook',
      instagram: 'Check our stories on Instagram',
      linkedin: 'Add us on LinkedIn',
      twitter: 'Check our Stories on Twitter',
    },
    usage_conditions: 'Terms of Use',
    usage_conditions_pm: 'Terms of Use',
    who: 'Who are we?',
    why: 'Why ?',
    worker: 'Worker',
  },
  form_errors: {
    address: 'Please select a city',
    job: 'Please enter a job',
  },
  form_labels: {
    address: 'City',
    address_pstf: 'Location',
    distance: '< {{distance}} miles',
    experience: 'Experience required',
    job: 'Job',
    sort: 'Sort by',
    type: 'Contract type',
  },
  form_option_labels: {
    experience: {
      all: 'All',
      any: 'First experience required',
      five_years: 'More than 5 years',
      none: 'No experience required',
      one_month: 'At least 1 month',
      one_year: 'At least 1 year',
      six_months: 'At least 6 months',
      three_months: 'At least 3 months',
      two_years: 'Between 2 years and 5 years',
    },
    sort: {
      publication: 'Publication date',
      relevance: 'Relevance',
    },
    type: {
      all: 'All',
      contract: 'Fixed contract',
      non_seasonal_temporary: 'Interim',
      permanent: 'Permanent contract',
      permanent_pstf: 'Direct hire',
      seasonal_temporary: 'Interim',
      temporary: 'Interim',
      temporary_pstf: 'Temp',
    },
    urgent: 'Urgent',
  },
  form_option_values: {
    experience: {
      any: 'first',
      five_years: '5 years and over',
      none: 'none',
      one_month: '1 month',
      one_year: '1 year',
      six_months: '6 months',
      three_months: '3 months',
      two_years: '2 years and above',
    },
    sort: {
      publication: 'publication',
      relevance: 'relevance',
    },
    type: {
      contract: 'fixed',
      non_seasonal_temporary: 'non-seasonal interim',
      permanent: 'permanent',
      seasonal_temporary: 'seasonal interim',
      temporary: 'interim',
    },
  },
  form_placeholders: {
    address: 'Search for a city',
    address_pstf: 'Search for an address',
    job: 'Search for a job',
    type: 'Search for a contract type',
  },
  form_title: 'Your search for',
  free_application_card: {
    button: 'Go',
    message: 'Send in your resume and we’ll get in touch as soon we find something for you.',
    title: 'Find your dream job yet?',
  },
  header: {
    findMission: 'Find a job',
    myApply: 'My Applications',
    partners: 'Partners',
  },
  home_page_offers: {
    buttons: {
      cities: 'Discover all cities',
      sectors: 'Discover all sectors',
    },
    title_1: '<span>{{formattedCount}}</span> Job openings throughout France',
    title_other: '<span>{{formattedCount}}</span> Job openings throughout France',
  },
  job_page: {
    heading: 'Work as a {{job}}',
    latest_job_offers: 'Our latest {{job}} offers',
    meta_description:
      'Find our temporary, permanent and fixed-term job offers for the profession of {{job}} and apply in a few clicks',
    meta_title: 'Our job offers for {{job}} - iziwork',
    title: 'Our <span>{{job}}</span> offers',
  },
  jobs_page: {
    meta_description:
      'Find our temporary, permanent, and fixed-term contract job offers and apply in just a few clicks',
    meta_title: 'Our job offers by profession - iziwork',
    title: 'All jobs',
  },
  latest_job_offers: {
    page: 'Page {{page}}',
    title: 'Our latest offers',
  },
  list_grid_layout: {
    cities: {
      title: 'Our offers by city',
    },
    jobs: {
      title: 'Our offers by job',
    },
    sectors: {
      title: 'Our offers by field',
    },
  },
  menu: {
    b2b_button: 'I am a company',
    cities: 'Cities',
    entreprise_button_mobile: 'Company',
    jobs: 'Jobs',
    link: {
      cities: 'View all cities',
      jobs: 'View all jobs',
      sectors: 'View all sectors',
    },
    sectors: 'Activity sectors',
  },
  meta_description: {
    jobOffer: {
      default: 'Consult our mission of {{title}} in {{city}}.',
      suffix: 'Apply now, work tomorrow!',
      type: {
        contract: 'Consult our fixed-term mission of {{title}} in {{city}}.',
        permanent: 'Consult our permanent mission of {{title}} in {{city}}.',
        temporary: 'Consult our interim mission of {{title}} in {{city}}.',
      },
    },
  },
  meta_social_description: {
    mission_description: 'Find your mission as {{displayName}} near {{city}}. Apply now, work tomorrow!',
    mission_title: '{{displayName}} - {{city}} ({{areaCode}}) - Job offers',
    partner_description: 'Dozens of offers near {{city}} ! Apply quickly and easily.',
    partner_title: 'Our job offers near {{city}} ({{areaCode}})',
  },
  missions: {
    about: 'About the mission',
    apply: 'Apply',
    back: 'Back to search',
    bonuses: 'Bonuses',
    certificates: 'Certificates',
    close_distance: 'close',
    contractType: 'Contrat type',
    details_tab_label: 'Details',
    distance: '{{distance}} miles away',
    experience: 'Experience',
    informations: 'Information',
    location: 'Location',
    mission_h1: {
      with_area: '{{title}} in {{city}} ({{areaCode}})',
      without_area: '{{title}} in {{city}}',
    },
    mission_title: {
      with_area: '{{title}} in {{city}} ({{areaCode}}) - Job offer',
      without_area: '{{title}} in {{city}} - Job offer',
    },
    no_certificates_required: 'No certificate required',
    no_experience_required: 'No experience required (summer job, etc.)',
    no_experience_required_pstf: 'No experience required',
    profile: 'Candidate Profile',
    published: 'Published ',
    remuneration: 'Remuneration',
    see_all_missions: 'See all his/her jobs',
    see_all_offers: 'See all offers',
    weekly_hours: {
      default: '{{hours}} hours / weekly',
      hours: '{{hours}} hours',
      per_week: 'per week',
    },
    workTime: 'Work time',
  },
  no_mission_modal: {
    button: {
      close: 'Close',
      next: 'Next',
    },
    download_app: 'Download the app now!',
    download_app_pm: 'Download the app now!',
    download_app_subtitle: 'Register and complete your profile in 5 minutes thanks to our CV analysis system.',
    download_app_subtitle_pstf: 'Register and complete your profile in 5 minutes thanks to our resume analysis system.',
    placeholder: {
      email: 'Your email address',
      phone: 'Your phone number',
    },
    step: 'Step {{step}} / 2',
    subtitle:
      'We are constantly looking for the best opportunities for you! Fill in your information, and we will inform you as soon as we have missions to offer you:',
    success: {
      body: 'Register and complete your profile in 5 minutes using our CV analysis system.',
      body_pstf: 'Register and complete your profile in 5 minutes using our resume analysis system.',
      subtitle: "You're almost there !",
      title: 'Find out new missions in our app',
    },
    title: 'It seems that no offers has been found!',
  },
  no_missions_result: {
    download_app: 'Download the app now!',
    download_app_pm: 'Download the app now!',
    download_hint: 'Download the application and we will inform you as soon as we have missions to offer you.',
    subtitle: 'We are constantly looking for the best opportunities for you!',
    title: 'Oops, looks like no deals were found!',
  },
  pain_points_page: {
    meta_description:
      "Recruitment, hard-to-fill jobs, compliance, administration, retention: iziwork's answers to the staffing challenges of companies.",
    meta_title: 'Your temporary staffing challenges - iziwork',
    title: 'Pain points',
  },
  salary: {
    gross_per_unit: {
      hourly: 'Gross/hour',
      hourly_pstf: 'Hourly',
      monthly: 'Gross/month',
      monthly_pstf: 'Monthly',
      yearly: 'Gross/year',
      yearly_pstf: 'Yearly',
    },
  },
  search_button: {
    label: 'Search',
  },
  search_params: {
    address: 'city',
    distance: 'distance',
    experience: 'experience',
    job: 'job',
    page: 'page',
    sort: 'sort',
    type: 'contract',
  },
  sector_page: {
    heading: 'Work in {{sector}}',
    latest_job_offers: 'Our latest offers in {{sector}}',
    meta_description:
      '{{sector}}: Find our temporary, permanent, and fixed-term contract job offers in your city. Apply online or on our app in just a few moments.',
    meta_title: '{{sector}} sector: temporary job offers - iziwork',
    title: 'Our offers in <span>{{sector}}</span>',
  },
  sectors_page: {
    meta_description:
      'Find our temporary, permanent, and fixed-term contract job offers and apply in just a few clicks',
    meta_title: 'Our job offers by sector - iziwork',
    title: 'All sectors of activity',
  },
  similar_offers: {
    title_nearby: 'Other offers near {{city}}',
    title_with_location: 'Other offers for {{title}} in {{city}}',
    title_without_city: 'Other offers nearby',
  },
  sitemap_page: {
    meta_description:
      'iziwork sitemap: all our temporary, fixed-term and permanent job offers, and our pages by city, job and sector.',
    meta_title: 'Sitemap - iziwork',
    title: 'Sitemap',
  },
  solutions_page: {
    meta_description:
      'Onsite, central staffing, automatic matching: iziwork solutions to recruit and manage temporary workers across all your sites.',
    meta_title: 'Our temporary staffing solutions for companies - iziwork',
    title: 'Solutions',
  },
  tags: {
    experience: {
      any: 'First experience required',
      five_years: 'More than 5 years of experience',
      none: 'No experience required',
      one_month: 'At least 1 month of experience',
      one_year: 'At least 1 year of experience',
      six_months: 'At least 6 months of experience',
      three_months: 'At least 3 months of experience',
      two_years: 'Between 2 years and 5 years of experience',
    },
  },
  title: {
    '404_error': 'Page not found - job offers',
    '404_error_pm': 'Page not found - Proman Solutions job offers',
    '404_error_pstf': 'Page not found - Proman Staffing job openings',
    '500_error': 'Unknown error - jobs',
    '500_error_pm': 'Unknown error - Proman Solutions job offers',
    '500_error_pstf': 'Unknown error - Proman Staffing job openings',
  },
  toasts: {
    application_error_body: 'Your application has not been taken into account, please try again later.',
    application_error_title: 'An error has occurred',
    install_app_sms_error_body: 'Your request has not been taken into account, please try again later.',
  },
  url: {
    askADemo: 'recrutement-interim',
    blog: 'blog',
    companySpace: 'entreprises',
    confidentiality: 'charte-de-confidentialite',
    cookie: 'politique-de-cookies',
    legalMentions: 'Legal notice',
    partners: 'partners',
    personalData: 'formulaire-exercice-droits',
    press: 'presse',
    usageConditions: 'conditions-generales-dutilisation',
    usageConditions_pstf: 'privacy-policy',
    who: 'a-propos',
    why: 'why',
  },
  welcome: 'Welcome',
  welcome_page: {
    meta_description:
      'Thousands of job offers accessible online or via our app with iziwork, the #1 digital temp agency. Find a mission near you and apply in 3 clicks.',
    meta_description_pm:
      'Proman Solutions temporary, fixed-term and permanent job offers. Find a mission near you and apply online in a few clicks.',
    meta_description_pstf:
      'Proman Staffing job openings: temporary and permanent positions near you. Find your next job and apply online in a few clicks.',
    meta_description_search_city:
      'Temporary and permanent job offers near {{city}}: find a mission close to you and apply in a few clicks.',
    meta_description_search_job:
      '{{job}} job offers, temporary and permanent: find a mission close to you and apply in a few clicks.',
    meta_description_search_job_city:
      '{{job}} job offers near {{city}}, temporary and permanent: apply in a few clicks.',
    meta_social_description: 'Positions to be filled near you! Easy and fast application.',
    meta_social_description_city: 'Openings near {{city}} ! Easy and fast application.',
    meta_social_title: 'Find our job offers near you',
    meta_social_title_city: 'Our job offers near {{city}}',
    meta_social_title_city_zipcode: 'Our vacancies near {{city}} ({{zipcode}})',
    meta_title: 'Our job offers',
    meta_title_city: '{{city}} - Our job offers',
    meta_title_city_pm: '{{city}} - Our job offers - Proman Solutions',
    meta_title_city_pstf: '{{city}} - Job openings - Proman Staffing',
    meta_title_city_zipcode: '{{city}} ({{zipcode}}) - Our job offers',
    meta_title_city_zipcode_pm: '{{city}} ({{zipcode}}) - Our job offers - Proman Solutions',
    meta_title_city_zipcode_pstf: '{{city}} ({{zipcode}}) - Job openings - Proman Staffing',
    meta_title_pm: 'Temporary, fixed-term and permanent job offers - Proman Solutions',
    meta_title_pstf: 'Job openings near you - Proman Staffing',
    missions_available_0: 'No offers available',
    missions_available_1: '1 offer found',
    missions_available_other: '{{count}} offers found',
    title: 'Our offers<br>near <span>at your place!</span>',
  },
};

export default en;
